// export function getTodayDateOnlyAsString()
// {
//     var today = new Date();
//     const yr = today.getFullYear();
//     const month = today.getMonth() + 1;
//     const date = today.getDate();
//     return yr +"-"+month+"-"+ date;
// }

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { getDisplayValue } from "./Utility";

dayjs.extend(utc);
dayjs.extend(timezone);

export function getDateOnlyAsString(inputDate)
{
    if (inputDate) {
      const yr = inputDate.getFullYear();
      const month =
        inputDate.getMonth() > 8
          ? inputDate.getMonth() + 1
          : "0" + (inputDate.getMonth() + 1);
      const date =
        inputDate.getDate() > 9
          ? inputDate.getDate()
          : "0" + inputDate.getDate();
      return yr + "-" + month + "-" + date;
    }
}

export function getDateOnlyFromString(inputDate)
{
    if(inputDate)
    {
        var dateComponents = inputDate.split("-");
        const yr = dateComponents[0];
        const month = dateComponents[1];
        const date = dateComponents[2];
        const returnValue = new Date();
        returnValue.setDate(date);
        returnValue.setMonth(month - 1);
        returnValue.setFullYear(yr);
        returnValue.setHours(0,0,0,0);
        return returnValue;
    }
}

export function getMonthDates(year, month) {
  const weeks = [];
  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  let currentWeek = new Array(7).fill(null); // A week array with 7 days (Sunday to Saturday)
  let dayCounter = 1;

  // Fill the first week with blank days until the first day of the month
  for (let i = firstDayOfMonth; i < 7; i++) {
    currentWeek[i] = dayCounter++;
  }
  weeks.push([...currentWeek]); // Push the first week to the weeks array

  // Fill the remaining weeks
  while (dayCounter <= daysInMonth) {
    currentWeek = new Array(7).fill(null); // Create a new week
    for (let i = 0; i < 7 && dayCounter <= daysInMonth; i++) {
      currentWeek[i] = dayCounter++;
    }
    weeks.push([...currentWeek]); // Push each week to the weeks array
  }

  return weeks;
}

export function compareDates(date1, date2)
{
  return 0;
}

export function addDays(date, numberOfDays)
{
  const passedDate = new Date(date);
  const newDate = new Date(
    passedDate.setTime(passedDate.getTime() + numberOfDays * 24 * 60 * 60 * 1000));
  
  return newDate
}

export function getDatesArray(currentDate, numberOfDays)
{
  var datesArray = [];
  for(var i = 0; i < numberOfDays; i++)
  {
    var tempDate = new Date(currentDate);
    datesArray.push(getDateOnlyAsString(addDays(tempDate, i)));
  }
  return datesArray;
}

export function convertDateTimeToFacilityTimeZone(dateTime, facilityTimeZone)
{
  return dayjs(dateTime).tz(facilityTimeZone, false).format();
}

// export function getTimeWithAMPM(time)
// {
//   new Date().se
export function convertUTCToTimeZone(dateTime, timeZone) {
  return dayjs.utc(dateTime).tz(timeZone);
  // const shortTimeZone = dayjs.tz(timeZone).format('z');
  // return `${formattedDate} ${shortTimeZone}`;
}

export function convertUTCToTimeZoneDateTimeString(dateTime, timeZone) {
  if(!dateTime) {
    return "Invalid Date";
  }
  return dayjs.utc(dateTime).tz(timeZone).format('ddd MMM DD, YYYY hh:mm A');
  // const shortTimeZone = dayjs.tz(timeZone).format('z');
  // return `${formattedDate} ${shortTimeZone}`;
}

export function convertUTCToTimeZoneDateString(dateTime, timeZone) {
  if(!dateTime) {
    return "Invalid Date";
  }
  return dayjs.utc(dateTime).tz(timeZone).format('ddd MMM DD');
  // const shortTimeZone = dayjs.tz(timeZone).format('z');
  // return `${formattedDate} ${shortTimeZone}`;
}

export function convertToUTC(dateTime) {
  return dayjs(dateTime).utc();
}


